import { render, staticRenderFns } from "./AddBlackCard.vue?vue&type=template&id=ee8faa26&"
import script from "./AddBlackCard.vue?vue&type=script&lang=js&"
export * from "./AddBlackCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports